
export const GET_PRODUCTS_LOADING = 'GET_PRODUCTS_LOADING';
export const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const PRODUCT_IMAGES_LOADING = 'PRODUCT_IMAGES_LOADING';

export const GET_RECIPES_LOADING = 'GET_RECIPES_LOADING';
export const GET_RECIPES_FAILED = 'GET_RECIPES_FAILED';
export const GET_RECIPES_SUCCESS = 'GET_RECIPES_SUCCESS';

export const GET_EVENTS_LOADING = 'GET_EVENTS_LOADING';
export const GET_EVENTS_FAILED = 'GET_EVENTS_FAILED';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';

export const UPDATE_VIEWED_LOCATION = 'UPDATE_VIEWED_LOCATION';
export const TOGGLE_NAV = 'TOGGLE_NAV';
export const TOGGLE_CONTACT = 'TOGGLE_CONTACT';

export const TOGGLE_SEARCH = 'TOGGLE_SEARCH';

export const TOGGLE_NUTRITION = 'TOGGLE_NUTRITION';
export const SET_NUTRI_FACTS_IMAGE = 'SET_NUTRI_FACTS_IMAGE';
export const TOGGLE_SINGLE_PRODUCT = 'TOGGLE_SINGLE_PRODUCT';
export const TOGGLE_SINGLE_EVENT = 'TOGGLE_SINGLE_EVENT';
export const GET_SINGLE_PRODUCT_LOADING = 'GET_SINGLE_PRODUCT_LOADING';
export const GET_SINGLE_PRODUCT_FAILED = 'GET_SINGLE_PRODUCT_FAILED';